// Money utilities with thousandth-digit rounding rule:
// Round to cents by inspecting the thousandth digit —
// if >= 5 round up, else round down.
export function roundMoney(value) {
  const v = Number(value);
  if (!Number.isFinite(v)) return 0;
  const sign = v < 0 ? -1 : 1;
  const abs = Math.abs(v);
  const scaled1000 = abs * 1000;
  const thousandth = Math.floor(scaled1000 + 1e-8) % 10;
  const scaled100 = abs * 100;
  const rounded = thousandth >= 5
    ? Math.ceil(scaled100 - 1e-8) / 100
    : Math.floor(scaled100 + 1e-8) / 100;
  return sign * rounded;
}

export function formatMoney(value) {
  return roundMoney(value).toFixed(2);
}

// Size utilities: same thousandth-digit rule to 2 decimals
export function roundSize(value) {
  const v = Number(value);
  if (!Number.isFinite(v)) return 0;
  const sign = v < 0 ? -1 : 1;
  const abs = Math.abs(v);
  const scaled1000 = abs * 1000;
  const thousandth = Math.floor(scaled1000 + 1e-8) % 10;
  const scaled100 = abs * 100;
  const rounded = thousandth >= 5
    ? Math.ceil(scaled100 - 1e-8) / 100
    : Math.floor(scaled100 + 1e-8) / 100;
  return sign * rounded;
}
